import { useRef, useState } from "react";
import "./ProductRange.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ProductRange = () => {
  let sliderRef: any = useRef(null);
  const [hoveredImage, setHoveredImage] = useState(null);

  const next = () => {
    sliderRef?.slickNext();
  };
  const previous = () => {
    sliderRef?.slickPrev();
  };

  const handleMouseEnter = (index: any) => {
    setHoveredImage(index);
  };

  const handleMouseLeave = () => {
    setHoveredImage(null);
  };

  const getImageStyle = (index: number) => {
    return hoveredImage === index
      ? {
          filter:
            "brightness(0) saturate(100%) invert(33%) sepia(92%) saturate(6706%) hue-rotate(203deg) brightness(92%) contrast(106%)",
        }
      : {};
  };

  const getTextStyle = (index: number) => {
    return hoveredImage === index
      ? { opacity: 1, transition: "opacity 0.3s ease-in-out" }
      : { opacity: 0, transition: "opacity 0.3s ease-in-out" };
  };

  const getBottleStyle = (index: number) => {
    return hoveredImage === index
      ? { transform: "scale(0.8)", transition: "transform 0.3s ease-in-out" } // Shrink on hover
      : { transform: "scale(1)", transition: "transform 0.3s ease-in-out" }; // Original size when not hovered
  };

  const settings = {
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    variableWidth: true,
  };

  return (
    <>
      <div className="product-range-container">
        <div className="product-range-heading-container">
          <div className="heading-section">THE HOUSE OF CAMPA</div>
          <div className="arrows-section">
            <img
              alt="arrow"
              className="left-arrow"
              src={`${process.env.REACT_APP_BASENAME}/svgs/arrow.svg`}
              onClick={previous}
            />
            <img
              alt="arrow"
              className="right-arrow"
              src={`${process.env.REACT_APP_BASENAME}/svgs/arrow.svg`}
              onClick={next}
            />
          </div>
        </div>
        <div className="product-cards-container">
          <Slider
            ref={(slider) => {
              sliderRef = slider;
            }}
            {...settings}
          >
            <div>
              <div className="product-card">
                <img
                  alt="campa-bottle"
                  src="https://campabeveragesadmin.ril.com/uploads/Campa_Bottle_BG_043ab6c63c.png"
                  className="product-card-bg-image"
                  style={{
                    ...getImageStyle(1),
                  }}
                  onMouseEnter={() => handleMouseEnter(1)}
                  onMouseLeave={handleMouseLeave}
                />
                <span className="product-card-main-heading">CAMPA</span>
                <span className="product-card-sub-heading">COLA</span>
                <p
                  style={{
                    ...getTextStyle(1),
                  }}
                  className="product-card-description"
                >
                  Reimagined for modern India, get refreshed with the Naye India
                  ka Apna Thanda.
                </p>
                <img
                  alt="bottle-hover"
                  style={{
                    ...getBottleStyle(1),
                  }}
                  className="product-card-child-image"
                  onMouseEnter={() => handleMouseEnter(1)}
                  onMouseLeave={handleMouseLeave}
                  src="	https://campabeveragesadmin.ril.com/uploads/Campa_Big_Bottle_Hover_cdca1d15fc_280f76901c.png"
                />
              </div>
            </div>
            <div>
              <div className="product-card">
                <img
                  alt="orange-bottle"
                  src="https://campabeveragesadmin.ril.com/uploads/Orange_Bottle_BG_076d5107c6.png"
                  className="product-card-bg-image"
                  style={{
                    ...getImageStyle(2),
                  }}
                  onMouseEnter={() => handleMouseEnter(2)}
                  onMouseLeave={handleMouseLeave}
                />
                <span className="product-card-main-heading">CAMPA</span>
                <span className="product-card-sub-heading">ORANGE</span>
                <p
                  style={{
                    ...getTextStyle(2),
                  }}
                  className="product-card-description"
                >
                  Indulged in a burst of flavour & fun with delicious and
                  playful taste of orange.
                </p>
                <img
                  alt="orange-big-bottle"
                  style={{
                    ...getBottleStyle(2),
                  }}
                  className="product-card-child-image"
                  onMouseEnter={() => handleMouseEnter(2)}
                  onMouseLeave={handleMouseLeave}
                  src="https://campabeveragesadmin.ril.com/uploads/Orange_Big_Bottle_Hover_cd42bf91e0_fa65dd0a7f.png"
                />
              </div>
            </div>
            <div>
              <div className="product-card">
                <img
                  alt="lemon-bottle"
                  src="https://campabeveragesadmin.ril.com/uploads/Lemon_Bottle_BG_93bf3cea5a.png"
                  className="product-card-bg-image"
                  style={{
                    ...getImageStyle(3),
                  }}
                  onMouseEnter={() => handleMouseEnter(3)}
                  onMouseLeave={handleMouseLeave}
                />
                <span className="product-card-main-heading">CAMPA</span>
                <span className="product-card-sub-heading">LEMON</span>
                <p
                  style={{
                    ...getTextStyle(3),
                  }}
                  className="product-card-description"
                >
                  Beat the heat with the refreshingly crisp & zingy thirst
                  quencher.
                </p>
                <img
                  alt="lemon-big-bottle"
                  style={{
                    ...getBottleStyle(3),
                  }}
                  className="product-card-child-image"
                  onMouseEnter={() => handleMouseEnter(3)}
                  onMouseLeave={handleMouseLeave}
                  src="	https://campabeveragesadmin.ril.com/uploads/Lemon_Big_Bottle_Hover_0475c5f2c7_7c368c3bcb.png"
                />
              </div>
            </div>
            <div>
              <div className="product-card">
                <img
                  alt="powerup-bottle"
                  src="https://campabeveragesadmin.ril.com/uploads/Powerup_Bottle_BG_9176b47dd3.png"
                  className="product-card-bg-image"
                  style={{
                    ...getImageStyle(4),
                  }}
                  onMouseEnter={() => handleMouseEnter(4)}
                  onMouseLeave={handleMouseLeave}
                />
                <span className="product-card-main-heading">CAMPA</span>
                <span className="product-card-sub-heading">POWERUP</span>
                <p
                  style={{
                    ...getTextStyle(4),
                  }}
                  className="product-card-description"
                >
                  A strong and energising Cola - A powerful refresher with a
                  fusion of flavours.
                </p>
                <img
                  alt="powerup-big-bottle"
                  style={{
                    ...getBottleStyle(4),
                  }}
                  className="product-card-child-image"
                  onMouseEnter={() => handleMouseEnter(4)}
                  onMouseLeave={handleMouseLeave}
                  src="	https://campabeveragesadmin.ril.com/uploads/Powerup_Big_Bottle_Hover_78828cdbbe_b8334a780f.png"
                />
              </div>
            </div>
            <div>
              <div className="product-card">
                <img
                  alt="cricket-bottle"
                  src="https://campabeveragesadmin.ril.com/uploads/Cricket_Bottle_BG_7939a8f69b.png"
                  className="product-card-bg-image"
                  style={{
                    ...getImageStyle(5),
                  }}
                  onMouseEnter={() => handleMouseEnter(5)}
                  onMouseLeave={handleMouseLeave}
                />
                <span className="product-card-main-heading">CAMPA</span>
                <span className="product-card-sub-heading">CRICKET</span>
                <p
                  style={{
                    fontSize: "14px",
                    ...getTextStyle(5),
                  }}
                  className="product-card-description"
                >
                  Powered with electrolytes this ultimate rehydrator is a
                  must-have for every passionate Indian cricket fan.
                </p>
                <img
                  alt="bottle-style"
                  style={{
                    ...getBottleStyle(5),
                  }}
                  className="product-card-child-image"
                  onMouseEnter={() => handleMouseEnter(5)}
                  onMouseLeave={handleMouseLeave}
                  src="	https://campabeveragesadmin.ril.com/uploads/Group_109_1_0d313c31ee.png"
                />
              </div>
            </div>
          </Slider>
        </div>
      </div>
    </>
  );
};

export default ProductRange;
